export const generateTemplate = (link: string, mnemonic: string) =>
  [
    `Use the link and passcode below to open, edit, and submit your changes:`,
    `Link: ${link}`,
    `Seed phrase: ${mnemonic}`,
  ].join('\n');
